/** "₹2,200" -> 2200. Strips everything but digits, so any currency-symbol/comma formatting in seafood.ts's display strings is safe to feed in. */
export function parsePriceToNumber(price: string): number {
  return Number(price.replace(/[^0-9]/g, "")) || 0;
}

export function formatInr(amount: number): string {
  return `₹${Math.round(amount).toLocaleString("en-IN")}`;
}
